export const FILTERS_API = 'filtersApi';
